export default __webpack_public_path__ + "static/media/drive.4feed9d0.svg";